import React from "react";

// Summary row + "can't be combined" note for the non-stackable seasonal promo.
export const SeasonalDiscountRow = ({ promo, testIdPrefix, codesIgnored = false }) => {
  if (!promo || !(promo.amount > 0)) return null;
  return (
    <div data-testid={`${testIdPrefix}-seasonal-discount`} className="space-y-1">
      <div className="flex justify-between items-baseline" style={{ color: "#8B2252" }}>
        <span className="flex items-center gap-1.5">
          {promo.name}
          <span
            className="text-[10px] font-medium tracking-wider uppercase px-1.5 py-0.5 rounded-full"
            style={{ background: "rgba(139,34,82,0.10)" }}
          >
            {promo.pct}% off
          </span>
        </span>
        <span data-testid={`${testIdPrefix}-seasonal-discount-amount`} className="font-medium">
          −${Number(promo.amount).toFixed(2)}
        </span>
      </div>
      <p
        data-testid={`${testIdPrefix}-seasonal-exclusive-note`}
        className="text-[11px] leading-snug"
        style={{ color: "#9a7a80" }}
      >
        {promo.allowFirst10
          ? "Can’t be combined with other discounts, except FIRST10 on a first order."
          : `Can’t be combined with other discounts${codesIgnored ? " — your promo codes and volume savings are paused for this order." : "."}`}
      </p>
    </div>
  );
};

export default SeasonalDiscountRow;
